<template>
    <BreadCrumb PageTitle="Liste des emprunts" />
    <MesEmprunts @statistiques-updated="updateStatistiques" />
</template>

<script lang="ts">
import { reactive, onMounted, defineComponent } from 'vue';
import MesEmprunts from '@/components/Emprunt/MesEmprunts.vue';
import BreadCrumb from '@/components/Common/BreadCrumb.vue';

export default defineComponent({
  name: "MesEmpruntsPage",
  components: {
    MesEmprunts,
    BreadCrumb
  },
  
  setup() {
    const statistiques = reactive({
      enCours: 0,
      termines: 0,
      enRetard: 0,
      total: 0
    });

    const updateStatistiques = (emprunts: any[]) => {
      // Méthode appelée par le composant enfant pour mettre à jour les statistiques
      calculerStatistiquesFromData(emprunts);
    };

    const calculerStatistiques = () => {
      // Cette méthode sera appelée au montage pour calculer les statistiques initiales
      // Pour l'instant, on utilise des valeurs par défaut
      // Dans une vraie application, on ferait un appel API séparé pour récupérer les statistiques
    };

    const calculerStatistiquesFromData = (emprunts: any[]) => {
      if (!emprunts || !Array.isArray(emprunts)) return;
      
      const stats = {
        enCours: 0,
        termines: 0,
        enRetard: 0,
        total: emprunts.length
      };
      
      emprunts.forEach(emprunt => {
        switch (emprunt.statutEmprunt) {
          case 'en_cours':
            stats.enCours++;
            break;
          case 'termine':
            stats.termines++;
            break;
          case 'en_retard':
            stats.enRetard++;
            break;
        }
      });
      
      statistiques.enCours = stats.enCours;
      statistiques.termines = stats.termines;
      statistiques.enRetard = stats.enRetard;
      statistiques.total = stats.total;
    };

    onMounted(() => {
      calculerStatistiques();
    });

    return {
      statistiques,
      updateStatistiques
    };
  }
});


// const statistiques = reactive({
//   enCours: 0,
//   termines: 0,
//   enRetard: 0,
//   total: 0
// });

// const updateStatistiques = (emprunts) => {
//   // Méthode appelée par le composant enfant pour mettre à jour les statistiques
//   calculerStatistiquesFromData(emprunts);
// };

// const calculerStatistiques = () => {
//   // Cette méthode sera appelée au montage pour calculer les statistiques initiales
//   // Pour l'instant, on utilise des valeurs par défaut
//   // Dans une vraie application, on ferait un appel API séparé pour récupérer les statistiques
// };

// const calculerStatistiquesFromData = (emprunts) => {
//   if (!emprunts || !Array.isArray(emprunts)) return;
  
//   const stats = {
//     enCours: 0,
//     termines: 0,
//     enRetard: 0,
//     total: emprunts.length
//   };
  
//   emprunts.forEach(emprunt => {
//     switch (emprunt.statutEmprunt) {
//       case 'en_cours':
//         stats.enCours++;
//         break;
//       case 'termine':
//         stats.termines++;
//         break;
//       case 'en_retard':
//         stats.enRetard++;
//         break;
//     }
//   });
  
//   statistiques.enCours = stats.enCours;
//   statistiques.termines = stats.termines;
//   statistiques.enRetard = stats.enRetard;
//   statistiques.total = stats.total;
// };

// onMounted(() => {
//   calculerStatistiques();
// });
</script>

